import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import apiService from '../services/api';
import UserMenu from './UserMenu';

const ProjectForm = ({ userName, onLogout }) => {
  const navigate = useNavigate();
  
  const [formData, setFormData] = useState({
    nome_projeto: '',
    solicitante_nome: userName || '',
    solicitante_setor: '',
    gestor_nome: '',
    centro_custo: '',
    // Campos da Matriz 5W2H - Linguagem simples para usuários leigos
    justificativas: '',           // Por quê? - Qual é o problema?
    objetivos_smart: '',          // O que? - Objetivos SMART
    beneficios: '',               // Benefícios esperados
    restricoes: '',               // Restrições de prazo e orçamento
    requisitos: '',               // O que os stakeholders querem
    entregaveis: '',              // Produtos gerados pelo projeto
    stakeholders_principais: '', // Decisores e diretores
    demais_stakeholders: '',       // Usuários e interessados
    equipe: '',                   // Áreas envolvidas
    como: '',                     // Estratégia de implementação
    quando: '',                   // Cronograma e prazos
    onde: '',                     // Local de implementação
    custo: '',                    // Investimento necessário
    riscos: '',                    // O que pode inviabilizar o projeto
    mapa_estrategico: ''           // Está vinculado com mapa estratégico?
  });

  const [setores, setSetores] = useState([]);
  const [gestores, setGestores] = useState([]);
  const [selectedSetor, setSelectedSetor] = useState(null);
  const [selectedGestor, setSelectedGestor] = useState(null);
  const [isGestorLocked, setIsGestorLocked] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  // Cores para cada campo da matriz - Paleta CEDISA
  const questionColors = {
    justificativas: { bg: 'from-orange-50 to-orange-100', icon: 'text-orange-600', accent: 'bg-orange-500', border: 'border-orange-200' },
    objetivos_smart: { bg: 'from-orange-50 to-orange-100', icon: 'text-orange-600', accent: 'bg-orange-500', border: 'border-orange-200' },
    beneficios: { bg: 'from-orange-50 to-orange-100', icon: 'text-orange-600', accent: 'bg-orange-500', border: 'border-orange-200' },
    restricoes: { bg: 'from-yellow-50 to-yellow-100', icon: 'text-yellow-600', accent: 'bg-yellow-500', border: 'border-yellow-200' },
    requisitos: { bg: 'from-yellow-50 to-yellow-100', icon: 'text-yellow-600', accent: 'bg-yellow-500', border: 'border-yellow-200' },
    entregaveis: { bg: 'from-yellow-50 to-yellow-100', icon: 'text-yellow-600', accent: 'bg-yellow-500', border: 'border-yellow-200' },
    stakeholders_principais: { bg: 'from-cyan-50 to-cyan-100', icon: 'text-cyan-600', accent: 'bg-cyan-500', border: 'border-cyan-200' },
    demais_stakeholders: { bg: 'from-cyan-50 to-cyan-100', icon: 'text-cyan-600', accent: 'bg-cyan-500', border: 'border-cyan-200' },
    equipe: { bg: 'from-cyan-50 to-cyan-100', icon: 'text-cyan-600', accent: 'bg-cyan-500', border: 'border-cyan-200' },
    como: { bg: 'from-green-50 to-green-100', icon: 'text-green-600', accent: 'bg-green-500', border: 'border-green-200' },
    quando: { bg: 'from-green-50 to-green-100', icon: 'text-green-600', accent: 'bg-green-500', border: 'border-green-200' },
    onde: { bg: 'from-green-50 to-green-100', icon: 'text-green-600', accent: 'bg-green-500', border: 'border-green-200' },
    custo: { bg: 'from-purple-50 to-purple-100', icon: 'text-purple-600', accent: 'bg-purple-500', border: 'border-purple-200' },
    riscos: { bg: 'from-yellow-50 to-yellow-100', icon: 'text-yellow-600', accent: 'bg-yellow-500', border: 'border-yellow-200' }
  };

  // Ícones para cada campo da matriz
  const questionIcons = {
    justificativas: (
      <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8.228 9c.549-1.165 2.03-2 3.772-2 2.21 0 4 1.343 4 3 0 1.4-1.278 2.575-3.006 2.907-.542.104-.994.54-.994 1.093m0 3h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
      </svg>
    ),
    objetivos_smart: (
      <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4M7.835 4.697a3.42 3.42 0 001.946-.806 3.42 3.42 0 014.438 0 3.42 3.42 0 001.946.806 3.42 3.42 0 013.138 3.138 3.42 3.42 0 00.806 1.946 3.42 3.42 0 010 4.438 3.42 3.42 0 00-.806 1.946 3.42 3.42 0 01-3.138 3.138 3.42 3.42 0 00-1.946.806 3.42 3.42 0 01-4.438 0 3.42 3.42 0 00-1.946-.806 3.42 3.42 0 01-3.138-3.138 3.42 3.42 0 00-.806-1.946 3.42 3.42 0 010-4.438 3.42 3.42 0 00.806-1.946 3.42 3.42 0 013.138-3.138z" />
      </svg>
    ),
    beneficios: (
      <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
      </svg>
    ),
    restricoes: (
      <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M18.364 18.364A9 9 0 005.636 5.636m12.728 12.728L5.636 5.636m12.728 12.728L18.364 5.636M5.636 18.364l12.728-12.728" />
      </svg>
    ),
    requisitos: (
      <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5H7a2 2 0 00-2 2v10a2 2 0 002 2h8a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01" />
      </svg>
    ),
    entregaveis: (
      <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4" />
      </svg>
    ),
    stakeholders_principais: (
      <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
      </svg>
    ),
    demais_stakeholders: (
      <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
      </svg>
    ),
    equipe: (
      <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
      </svg>
    ),
    como: (
      <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z" />
      </svg>
    ),
    quando: (
      <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
      </svg>
    ),
    onde: (
      <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
      </svg>
    ),
    custo: (
      <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1" />
      </svg>
    ),
    riscos: (
      <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L3.732 16.5c-.77.833.192 2.5 1.732 2.5z" />
      </svg>
    )
  };

  // Labels dos campos da matriz - Linguagem simples para usuários leigos
  const questionLabels = {
    justificativas: 'Por que este projeto é necessário?',
    objetivos_smart: 'Quais são os objetivos do projeto?',
    beneficios: 'Que benefícios este projeto trará?',
    restricoes: 'Quais são as limitações de prazo e orçamento?',
    requisitos: 'O que exatamente precisa ser feito?',
    entregaveis: 'Que produtos ou resultados serão entregues?',
    stakeholders_principais: 'Quem são os principais decisores?',
    demais_stakeholders: 'Quem mais será afetado pelo projeto?',
    equipe: 'Quais áreas da empresa estarão envolvidas?',
    como: 'Como o projeto será executado?',
    quando: 'Qual o cronograma e prazos?',
    onde: 'Onde será implementado?',
    custo: 'Qual o investimento necessário?',
    riscos: 'O que pode dar errado no projeto?'
  };

  // Placeholders dos campos da matriz - Linguagem simples e direta
  const questionPlaceholders = {
    justificativas: 'Explique qual problema ou necessidade motiva este projeto. Por que ele é importante para a empresa?',
    objetivos_smart: 'Descreva os objetivos específicos, mensuráveis e com prazo definido. O que exatamente queremos alcançar?',
    beneficios: 'Liste os benefícios esperados: economia de tempo, redução de custos, melhoria na qualidade, etc.',
    restricoes: 'Mencione limitações de prazo, orçamento, recursos ou outras restrições que podem afetar o projeto.',
    requisitos: 'Descreva o que exatamente precisa ser desenvolvido, implementado ou entregue.',
    entregaveis: 'Liste os produtos, documentos ou resultados que serão entregues ao final do projeto.',
    stakeholders_principais: 'Identifique os principais decisores: diretores, gerentes, clientes que aprovarão o projeto.',
    demais_stakeholders: 'Mencione usuários finais, equipes afetadas e outras pessoas interessadas no projeto.',
    equipe: 'Liste as áreas, departamentos ou equipes que estarão envolvidas na execução do projeto.',
    como: 'Descreva a estratégia ou abordagem que será usada para executar o projeto. Se não souber, indique alguém que possa informar.',
    quando: 'Defina o cronograma, marcos importantes e prazos para entrega.',
    onde: 'Especifique onde o projeto será implementado: localização física, sistemas, departamentos.',
    custo: 'Estime o investimento necessário: recursos humanos, tecnologia, equipamentos, etc.',
    riscos: 'Identifique possíveis problemas, obstáculos ou situações que podem inviabilizar o projeto.'
  };

  useEffect(() => {
    loadSetores();
  }, []);

  useEffect(() => {
    if (selectedSetor) {
      loadGestores(selectedSetor.label);
    } else {
      setGestores([]);
      setSelectedGestor(null);
    }
  }, [selectedSetor]);

  const loadSetores = async () => {
    try {
      const data = await apiService.getSetores();
      const options = data.map(s => ({ value: s.id, label: s.nome }));
      setSetores(options);
      setIsLoading(false);
    } catch (error) {
      toast.error('Erro ao carregar setores');
      setIsLoading(false);
    }
  };

  const loadGestores = async (setorNome) => {
    try {
      const data = await apiService.getGestores(setorNome);
      const options = data.map(g => ({ value: g.id, label: g.nome_completo }));
      setGestores(options);
      
      // Se houver apenas um gestor, selecionar automaticamente e travar o campo
      if (options.length === 1) {
        const unicoGestor = options[0];
        setSelectedGestor(unicoGestor);
        handleInputChange('gestor_nome', unicoGestor.label);
        setIsGestorLocked(true);
        toast.info(`Gestor ${unicoGestor.label} selecionado automaticamente`);
      } else {
        // Limpar seleção se houver múltiplos gestores e destravar o campo
        setSelectedGestor(null);
        handleInputChange('gestor_nome', '');
        setIsGestorLocked(false);
      }
    } catch (error) {
      toast.error('Erro ao carregar gestores');
    }
  };

  const handleInputChange = (field, value) => {
    setFormData(prev => ({
      ...prev,
      [field]: value
    }));
  };

  // Limites de caracteres para cada campo da matriz
  const questionLimits = {
    justificativas: { min: 50, max: Infinity },
    objetivos_smart: { min: 50, max: Infinity },
    beneficios: { min: 30, max: Infinity },
    restricoes: { min: 30, max: Infinity },
    requisitos: { min: 50, max: Infinity },
    entregaveis: { min: 30, max: Infinity },
    stakeholders_principais: { min: 30, max: Infinity },
    demais_stakeholders: { min: 30, max: Infinity },
    equipe: { min: 30, max: Infinity },
    como: { min: 2, max: Infinity },
    quando: { min: 30, max: Infinity },
    onde: { min: 30, max: Infinity },
    custo: { min: 2, max: Infinity },
    riscos: { min: 30, max: Infinity }
  };

  // Mapeamento dos campos para as partes da matriz 5W2H
  const matrizMapping = {
    justificativas: 'POR QUÊ',
    objetivos_smart: 'O QUE',
    beneficios: 'BENEFÍCIOS',
    restricoes: 'RESTRIÇÕES',
    requisitos: 'REQUISITOS',
    entregaveis: 'ENTREGÁVEIS',
    stakeholders_principais: 'STAKEHOLDERS',
    demais_stakeholders: 'STAKEHOLDERS',
    equipe: 'EQUIPE',
    como: 'COMO',
    quando: 'QUANDO',
    onde: 'ONDE',
    custo: 'CUSTO',
    riscos: 'RISCOS'
  };

  const validateForm = () => {
    const requiredFields = ['nome_projeto', 'solicitante_setor', 'gestor_nome', 'centro_custo'];
    const requiredQuestions = ['justificativas', 'objetivos_smart', 'beneficios', 'restricoes', 'requisitos', 'entregaveis', 'stakeholders_principais', 'demais_stakeholders', 'equipe', 'como', 'quando', 'onde', 'custo', 'riscos'];

    // Validar campos obrigatórios
    for (const field of requiredFields) {
      if (!formData[field]) {
        toast.error(`Campo obrigatório: ${field}`);
        return false;
      }
    }

    // Validar nome do projeto (mínimo e máximo)
    if (formData.nome_projeto.length < 5) {
      toast.error('Nome do projeto deve ter pelo menos 5 caracteres');
      return false;
    }

    // Validar centro de custo
    if (!formData.centro_custo || formData.centro_custo.length !== 4 || !/^\d{4}$/.test(formData.centro_custo)) {
      toast.error('Centro de custo deve conter exatamente 4 dígitos numéricos');
      return false;
    }

    // Validar perguntas com limites específicos
    for (const question of requiredQuestions) {
      const text = formData[question] || '';
      const limits = questionLimits[question];
      
      if (text.length < limits.min) {
        toast.error(`A pergunta "${questionLabels[question]}" deve ter pelo menos ${limits.min} caracteres`);
        return false;
      }
      
      if (limits.max !== Infinity && text.length > limits.max) {
        toast.error(`A pergunta "${questionLabels[question]}" deve ter no máximo ${limits.max} caracteres`);
        return false;
      }
    }

    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!validateForm()) {
      return;
    }

    setIsSubmitting(true);

    try {
      const projetoData = {
        ...formData,
        solicitante_setor: selectedSetor.label,
        gestor_nome: selectedGestor.label
      };

      const response = await apiService.createProjeto(projetoData);
      
      toast.success('Projeto criado com sucesso!');
      
      // Abrir automaticamente nova aba com a matriz
      const identificadorUnico = response.data.identificador_unico;
      const matrizUrl = `${window.location.origin}/projetos/${identificadorUnico}`;
      
      // Abrir nova aba com a matriz
      window.open(matrizUrl, '_blank');
      
      // Mostrar informações do projeto criado
      toast.info(
        <div>
          <p>✅ Projeto criado com sucesso!</p>
          <p className="text-sm mt-2">ID: {identificadorUnico}</p>
          <p className="text-sm mt-1">📊 Matriz aberta em nova aba</p>
        </div>
      );
      
      // Reset form
      setFormData({
        nome_projeto: '',
        solicitante_nome: userName || '',
        solicitante_setor: '',
        gestor_nome: '',
        centro_custo: '',
        justificativas: '',
        objetivos_smart: '',
        beneficios: '',
        restricoes: '',
        requisitos: '',
        entregaveis: '',
        stakeholders_principais: '',
        demais_stakeholders: '',
        equipe: '',
        como: '',
        quando: '',
        onde: '',
        custo: '',
        riscos: '',
        mapa_estrategico: ''
      });
      setSelectedSetor(null);
      setSelectedGestor(null);
      
    } catch (error) {
      toast.error('Erro ao criar projeto. Tente novamente.');
    } finally {
      setIsSubmitting(false);
    }
  };

  const getCharacterCount = (text) => {
    return text ? text.length : 0;
  };

  const getProgressPercentage = (text, questionKey) => {
    const count = getCharacterCount(text);
    const limits = questionLimits[questionKey];
    return Math.min((count / limits.min) * 100, 100);
  };

  if (isLoading) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto mb-4"></div>
          <p className="text-gray-600">Carregando formulário...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 via-blue-50 to-indigo-100">
      {/* CSS para animações sutis */}
      <style jsx>{`
        @keyframes slideInLeft {
          from {
            opacity: 0;
            transform: translateX(-30px);
          }
          to {
            opacity: 1;
            transform: translateX(0);
          }
        }
        
        @keyframes slideInRight {
          from {
            opacity: 0;
            transform: translateX(30px);
          }
          to {
            opacity: 1;
            transform: translateX(0);
          }
        }
        
        @keyframes slideInUp {
          from {
            opacity: 0;
            transform: translateY(30px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
        
        .animate-slide-in-left {
          opacity: 0;
          transform: translateX(-30px);
          animation: slideInLeft 0.6s ease-out forwards;
        }
        
        .animate-slide-in-right {
          opacity: 0;
          transform: translateX(30px);
          animation: slideInRight 0.6s ease-out forwards;
        }
        
        .animate-slide-in-up {
          opacity: 0;
          transform: translateY(30px);
          animation: slideInUp 0.6s ease-out forwards;
        }
        
        .animate-delay-100 {
          animation-delay: 0.1s;
        }
        
        .animate-delay-200 {
          animation-delay: 0.2s;
        }
        
        .animate-delay-300 {
          animation-delay: 0.3s;
        }
        
        .animate-delay-400 {
          animation-delay: 0.4s;
        }
        
        .animate-delay-500 {
          animation-delay: 0.5s;
        }
        
        .animate-delay-600 {
          animation-delay: 0.6s;
        }
        
        .animate-delay-700 {
          animation-delay: 0.7s;
        }
        
        .animate-delay-800 {
          animation-delay: 0.8s;
        }
        
        .animate-delay-900 {
          animation-delay: 0.9s;
        }
        
        .animate-delay-1000 {
          animation-delay: 1.0s;
        }
        
        .animate-delay-1100 {
          animation-delay: 1.1s;
        }
        
        .animate-delay-1200 {
          animation-delay: 1.2s;
        }
        
        .animate-delay-1300 {
          animation-delay: 1.3s;
        }
        
        .animate-delay-1400 {
          animation-delay: 1.4s;
        }
        
        .animate-delay-1500 {
          animation-delay: 1.5s;
        }
        
        .animate-delay-1600 {
          animation-delay: 1.6s;
        }
        
        .animate-delay-1700 {
          animation-delay: 1.7s;
        }
        
        .animate-delay-1800 {
          animation-delay: 1.8s;
        }
        
        .animate-delay-1900 {
          animation-delay: 1.9s;
        }
        
        .animate-delay-2000 {
          animation-delay: 2.0s;
        }
      `}</style>

      {/* Header Moderno */}
      <div className="bg-white border-b border-gray-200 px-6 py-4 shadow-sm">
        <div className="flex items-center justify-between">
          {/* Título da página à esquerda */}
          <div className="flex-1 animate-slide-in-left">
            <h1 className="text-xl font-bold" style={{ color: '#090E3A' }}>Propor Projeto</h1>
            <p className="text-sm text-gray-600 font-medium">Nova Proposta • CEDISA</p>
          </div>
          
          {/* Logo CEDISA centralizada (botão para home) */}
          <div className="flex-1 flex justify-center">
            <button 
              onClick={() => navigate('/')}
              className="hover:opacity-80 transition-opacity duration-200"
            >
              <img src="cedisa-logo.png" alt="Cedisa Logo" className="h-10 drop-shadow-sm" />
            </button>
          </div>
          
          {/* Nome do usuário na direita */}
          <div className="flex-1 flex justify-end animate-slide-in-right">
            <UserMenu userName={userName} onLogout={onLogout} />
          </div>
        </div>
      </div>

      {/* Aviso Importante */}
      <div className="bg-red-50 border-l-4 border-red-400 p-4 mx-6 mt-4 rounded-r-lg shadow-sm animate-slide-in-up animate-delay-200">
        <div className="flex items-center">
          <div className="flex-shrink-0">
            <svg className="h-5 w-5 text-red-400" viewBox="0 0 20 20" fill="currentColor">
              <path fillRule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
            </svg>
          </div>
          <div className="ml-3">
            <p className="text-sm text-red-700 font-semibold">
              <strong>ATENÇÃO:</strong> Esta é uma <strong>SOLICITAÇÃO</strong> de projeto. 
              O envio desta solicitação <strong>NÃO GARANTE</strong> que será aprovada pela CEDISA. 
              Todas as solicitações passam por análise e aprovação dos responsáveis.
            </p>
          </div>
        </div>
      </div>

      <div className="max-w-6xl mx-auto px-6 py-8">
        <form onSubmit={handleSubmit} className="space-y-8">
          
          {/* Seção Superior - Informações do Gestor */}
          <div className="bg-white/90 backdrop-blur-sm rounded-2xl shadow-xl border border-white/20 p-8 relative overflow-hidden animate-slide-in-up animate-delay-300">
            <div className="relative z-10">
              <div className="flex items-center gap-4 mb-8">
                <div className="w-16 h-16 rounded-2xl flex items-center justify-center shadow-lg" style={{ background: 'linear-gradient(135deg, #090E3A 0%, #1a2051 100%)' }}>
                  <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                  </svg>
                </div>
                <div>
                  <h2 className="text-2xl font-bold" style={{ color: '#090E3A' }}>Informações</h2>
                  <p className="text-gray-600">Dados do responsável pela proposta</p>
                </div>
              </div>

            <div className="space-y-6">
              {/* Nome do Projeto - Primeira linha */}
              <div className="space-y-3 animate-slide-in-up animate-delay-300">
                <label className="block text-base font-semibold" style={{ color: '#090E3A' }}>
                  Nome do Projeto <span className="text-red-500 ml-1 text-sm">*</span>
                </label>
                <input
                  type="text"
                  value={formData.nome_projeto}
                  onChange={(e) => handleInputChange('nome_projeto', e.target.value)}
                  placeholder="Digite o nome do projeto"
                  maxLength="30"
                  className="w-full px-4 py-4 border-2 border-gray-300 rounded-xl focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-300 hover:border-gray-400 text-base bg-white/80 backdrop-blur-sm"
                  required
                />
              </div>

              {/* Setor, Centro de Custo e Gestor - Segunda linha em grade */}
              <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                {/* Setor */}
                <div className="space-y-3 animate-slide-in-up animate-delay-400">
                  <label className="block text-base font-semibold" style={{ color: '#090E3A' }}>
                    Setor <span className="text-red-500 ml-1 text-sm">*</span>
                  </label>
                  <select
                    value={selectedSetor?.value || ''}
                    onChange={(e) => {
                      const setor = setores.find(s => s.value === parseInt(e.target.value));
                      setSelectedSetor(setor);
                      handleInputChange('solicitante_setor', setor?.label || '');
                    }}
                    className="w-full px-4 py-4 border-2 border-gray-300 rounded-xl focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-300 hover:border-gray-400 text-base bg-white/80 backdrop-blur-sm"
                    required
                    title={selectedSetor?.label || 'Selecione o setor'}
                  >
                    <option value="">Selecione o setor</option>
                    {setores.map(setor => (
                      <option key={setor.value} value={setor.value} title={setor.label}>
                        {setor.label}
                      </option>
                    ))}
                  </select>
                </div>

                {/* Centro de Custo */}
                <div className="space-y-3 animate-slide-in-up animate-delay-400">
                  <label className="block text-base font-semibold" style={{ color: '#090E3A' }}>
                    Centro de Custo <span className="text-red-500 ml-1 text-sm">*</span>
                  </label>
                  <input
                    type="text"
                    value={formData.centro_custo}
                    onChange={(e) => {
                      const value = e.target.value.replace(/\D/g, '').slice(0, 4);
                      handleInputChange('centro_custo', value);
                    }}
                    placeholder="0000"
                    maxLength="4"
                    className="w-full px-4 py-4 border-2 border-gray-300 rounded-xl focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-300 hover:border-gray-400 text-base bg-white/80 backdrop-blur-sm"
                    required
                  />
                </div>

                {/* Gestor */}
                <div className="space-y-3 animate-slide-in-up animate-delay-400">
                  <label className="block text-base font-semibold" style={{ color: '#090E3A' }}>
                    Gestor <span className="text-red-500 ml-1 text-sm">*</span>
                    
                  </label>
                  <select
                    value={selectedGestor?.value || ''}
                    onChange={(e) => {
                      const gestor = gestores.find(g => g.value === parseInt(e.target.value));
                      setSelectedGestor(gestor);
                      handleInputChange('gestor_nome', gestor?.label || '');
                    }}
                    className={`w-full px-4 py-4 border-2 border-gray-300 rounded-xl focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-300 hover:border-gray-400 text-base bg-white/80 backdrop-blur-sm ${
                      isGestorLocked ? 'bg-gray-100 cursor-not-allowed opacity-75' : ''
                    }`}
                    required
                    disabled={!selectedSetor || isGestorLocked}
                    title={selectedGestor?.label || 'Selecione o gestor'}
                  >
                    <option value="">Selecione o gestor</option>
                    {gestores.map(gestor => (
                      <option key={gestor.value} value={gestor.value} title={gestor.label}>
                        {gestor.label}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            </div>
            </div>
          </div>

          {/* Seção Inferior - Perguntas do Projeto */}
          <div className="space-y-6">
            <div className="text-center mb-8 animate-slide-in-up animate-delay-200">
              <h2 className="text-3xl font-bold mb-4" style={{ color: '#090E3A' }}>Conte-nos sobre seu projeto</h2>
              <p className="text-lg text-gray-600 max-w-3xl mx-auto">
                Para entendermos melhor sua proposta, precisamos de algumas informações. São apenas 14 perguntas que são necessárias para estruturar o projeto
              </p>
            </div>

            {/* Grid de perguntas - Layout vertical otimizado para notebooks */}
            <div className="space-y-6">
              {Object.entries(questionLabels).map(([key, label], index) => {
                const colors = questionColors[key];
                const icon = questionIcons[key];
                const placeholder = questionPlaceholders[key];
                const charCount = getCharacterCount(formData[key]);
                const limits = questionLimits[key];
                const progress = getProgressPercentage(formData[key], key);
                const isValid = charCount >= limits.min && (limits.max === Infinity || charCount <= limits.max);
                const isOverLimit = limits.max !== Infinity && charCount > limits.max;

                return (
                  <div
                    key={key}
                    className={`bg-white/90 backdrop-blur-sm rounded-2xl shadow-lg border-2 p-5 transition-all duration-300 hover:shadow-xl animate-slide-in-up animate-delay-${300 + (index * 50)} ${
                      isValid ? `${colors.border} bg-gradient-to-br ${colors.bg}` : 'border-gray-200'
                    }`}
                  >
                    {/* Header da pergunta */}
                    <div className="flex items-start gap-3 mb-3">
                      <div className={`w-12 h-12 bg-gradient-to-br ${colors.bg} rounded-xl flex items-center justify-center shadow-lg group-hover:scale-110 transition-transform duration-300`}>
                        <div className={colors.icon}>
                          {icon}
                        </div>
                      </div>
                      <div className="flex-1">
                        <div className="flex items-center justify-between mb-1">
                          <h3 className="text-base font-bold text-gray-900" style={{ color: '#111827' }}>
                            {label} <span className="text-red-500 ml-1 text-sm">*</span>
                          </h3>
                          <div className="bg-blue-100 text-blue-800 text-xs font-semibold px-2 py-1 rounded-full">
                            {matrizMapping[key]}
                          </div>
                        </div>
                        <p className="text-sm text-gray-500 mb-3">
                          Mínimo: {limits.min} caracteres{limits.max !== Infinity ? ` • Máximo: ${limits.max} caracteres` : ''}
                        </p>
                        <div className="flex items-center gap-3">
                          <div className="flex-1 bg-gray-200 rounded-full h-2">
                            <div
                              className={`h-2 rounded-full transition-all duration-500 ${isValid ? colors.accent : 'bg-gray-400'}`}
                              style={{ width: `${progress}%` }}
                            />
                          </div>
                          <span className={`text-sm font-semibold ${isValid ? 'text-green-600' : isOverLimit ? 'text-red-600' : 'text-gray-500'}`}>
                            {charCount}/{limits.max === Infinity ? '∞' : limits.max}
                          </span>
                        </div>
                        {isValid && (
                          <div className="flex items-center gap-1 mt-2">
                            <svg className="w-4 h-4 text-green-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                            </svg>
                            <span className="text-sm text-green-600 font-medium">Resposta completa!</span>
                          </div>
                        )}
                        {isOverLimit && (
                          <div className="flex items-center gap-1 mt-2">
                            <svg className="w-4 h-4 text-red-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                            </svg>
                            <span className="text-sm text-red-600 font-medium">Máximo {limits.max} caracteres!</span>
                          </div>
                        )}
                      </div>
                    </div>

                    {/* Textarea */}
                    <textarea
                      value={formData[key]}
                      onChange={(e) => handleInputChange(key, e.target.value)}
                      placeholder={placeholder}
                      rows={4}
                      className={`w-full px-4 py-4 border-2 rounded-xl focus:ring-2 focus:ring-blue-500 focus:border-transparent resize-none transition-all duration-300 bg-white/80 backdrop-blur-sm ${
                        isValid 
                          ? 'border-green-300 bg-green-50/50 focus:ring-green-500' 
                          : isOverLimit
                          ? 'border-red-300 bg-red-50/50 focus:ring-red-500'
                          : 'border-gray-300 hover:border-gray-400'
                      }`}
                      maxLength={limits.max === Infinity ? undefined : limits.max}
                      required
                    />
                  </div>
                );
              })}
              {/* Campo: Vínculo com o mapa estratégico */}
              <div className="space-y-3">
                <label className="block text-base font-semibold" style={{ color: '#090E3A' }}>
                  Está vinculado com o mapa estratégico? Se sim, como?
                </label>
                <textarea
                  value={formData.mapa_estrategico}
                  onChange={e => handleInputChange('mapa_estrategico', e.target.value)}
                  placeholder="Descreva se há vínculo, e de que forma, com o mapa estratégico da organização."
                  rows={3}
                  className="w-full px-4 py-4 border-2 border-gray-300 rounded-xl focus:ring-2 focus:ring-blue-500 focus:border-transparent resize-none transition-all duration-300 bg-white/80 backdrop-blur-sm"
                />
              </div>
            </div>
          </div>

          {/* Botão de Submit Moderno */}
          <div className="flex justify-center pt-10 animate-slide-in-up animate-delay-400">
            <button
              type="submit"
              disabled={isSubmitting}
              className={`px-12 py-5 rounded-2xl font-bold text-xl transition-all duration-300 transform hover:scale-105 ${
                isSubmitting
                  ? 'bg-gray-400 text-gray-200 cursor-not-allowed'
                  : 'text-white shadow-2xl hover:shadow-3xl'
              }`}
              style={!isSubmitting ? { 
                background: 'linear-gradient(135deg, #E85C1E 0%, #ff7a3d 100%)',
                border: 'none',
                boxShadow: '0 20px 40px rgba(232, 92, 30, 0.3)'
              } : {}}
            >
              {isSubmitting ? (
                <div className="flex items-center gap-3">
                  <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-white"></div>
                  <span>Enviando Proposta...</span>
                </div>
              ) : (
                <div className="flex items-center gap-3">
                  <span>Enviar Proposta</span>
                </div>
              )}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ProjectForm;